import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { useSelector } from "react-redux";
import LoginPage from "../pages/auth/login";
import AdminPanel from "../pages/admin";
import AdminReports from "../pages/admin/reports";
import BrandsPage from "../pages/admin/brands";
import GlassesPage from "../pages/admin/glasses";
import ColorsPage from "../pages/admin/colors";
import ColorCategoriesPage from "../pages/admin/color-categories";
import SpecialFeaturesPage from "../pages/admin/special-features";
import LensesPage from "../pages/admin/lenses";
import CoordinationPage from "../pages/admin/coordination";

// import { Role } from "../constants/enums";
// import LandingContainer from "../pages/landing";

// import AdminLoginPage from "../pages/auth/admin";
// import AdminForgetPage from "../pages/auth/forget";

// import CustomerPanel from "../pages/customer";
// import CoordinatorPanel from "../pages/coordinator";
// import BranchPanel from "../pages/branch";

// import Customers from "../pages/_shared/customers/customers";
// import CustomerGroups from "../pages/_shared/customers/group";

// import AdminBranches from "../pages/admin/branches";
// import AdminCoordinators from "../pages/admin/coordinators";
// import AdminServices from "../pages/admin/services";
// import AdminCarItemGroups from "../pages/admin/carItems/group";
// import AdminCarItems from "../pages/admin/carItems/item";
// import AdminCarBrands from "../pages/admin/cars/brands";
// import AdminCarModels from "../pages/admin/cars/models";
// import AdminCars from "../pages/_shared/cars";
// import AdminBlogs from "../pages/admin/blogs";
// import AdminProfile from "../pages/admin/profile";

// import CoordinatorRequests from "../pages/coordinator/requests";

// import BranchAppointments from "../pages/branch/appointments";
// import BranchRequests from "../pages/branch/requests";

// import CustomerCars from "../pages/customer/my-cars";
// import CustomerProfile from "../pages/customer/profile";
// import CustomerRequests from "../pages/customer/requests";

// import HomePage from "../pages/landing/home";
// import AboutPage from "../pages/landing/about";
// import ContactPage from "../pages/landing/contact";
// import BlogPage from "../pages/landing/blog";

// import InvoicePage from "../pages/invoice";
import PaymentPage from "../pages/payment";
// import UpdateAccount from "../pages/auth/update-account";
import { useGlobalStyles } from "../theme";
import CustomersPage from "../pages/admin/users";
import OrdersPage from "../pages/admin/orders";
import AccessoriesPage from "../pages/admin/accessories";
import AccessoryCategoriesPage from "../pages/admin/accessory-categories";
import InsurancesPage from "../pages/admin/insurances";
import ShippingMethodsPage from "../pages/admin/shipping-methods";
import { SettingsPage } from "../pages/admin/settings";
import GlassesStockPage from "../pages/admin/glasses-stock";
import FaqPage from "../pages/admin/faq";
import AboutUs from "../pages/admin/about-us";
import TermsConditions from "../pages/admin/terms-conditions";
import MainPagePage from "../pages/admin/main-page";
import { AdsPage } from "../pages/admin/ads";
import CartInquiryPage from "../pages/admin/cart-inquiry";
import TagsPage from "../pages/admin/tags";
import BlogsPage from "../pages/admin/blogs";
import CouponPage from "../pages/admin/coupon";
import ChangeGrouply from "../pages/admin/changeGroup";
import FormPage from "../pages/admin/form";
import SpecialSettingPage from "../pages/admin/specials";
import PageBuilderPage from "../pages/admin/page-builder";
import InstallmentPage from "../pages/admin/installment";
import RedirectPage from "../pages/admin/redirect";
import InPersonOrdersPage from "../pages/admin/in-person-orders";
import InPersonPurchasePage from "../pages/admin/in-person-orders/create";
import UserFlowAnalyticsPage from "../pages/admin/user-flow-analytics";
import CurrenciesPage from "../pages/admin/currencies";

export default function Navigation() {
  const { account } = useSelector((state) => state.auth);

  useGlobalStyles();

  if (!account) {
    return (
      <Router>
        <Switch>
          <Route path="/payment/:field">
            <PaymentPage />
          </Route>
          <Route path="*">
            <LoginPage />
          </Route>
        </Switch>
      </Router>
    );
  }

  return (
    <Router>
      <Switch>
        <Route path="/payment/:field">
          <PaymentPage />
        </Route>
        <Route path="*">
          <AdminPanel>
            <Switch>
              <Route path="/admin/reports">
                <AdminReports />
              </Route>
              <Route path="/analytics/user-flow">
                <UserFlowAnalyticsPage />
              </Route>
              <Route path="/admin/orders">
                <OrdersPage />
              </Route>
              <Route path="/admin/in-person-orders">
                <InPersonOrdersPage />
              </Route>
              <Route path="/admin/in-person-purchase">
                <InPersonPurchasePage />
              </Route>
              <Route path="/admin/change-group">
                <ChangeGrouply />
              </Route>
              <Route path="/admin/coordination">
                <CoordinationPage />
              </Route>
              <Route path="/admin/req-glass">
                <CartInquiryPage />
              </Route>
              <Route path="/admin/tags">
                <TagsPage />
              </Route>
              <Route path="/admin/glasses-stock">
                <GlassesStockPage />
              </Route>
              <Route path="/admin/brands">
                <BrandsPage />
              </Route>
              <Route path="/admin/glasses">
                <GlassesPage />
              </Route>
              <Route path="/admin/currencies">
                <CurrenciesPage />
              </Route>
              <Route path="/admin/accessories">
                <AccessoriesPage />
              </Route>
              <Route path="/admin/accessory-categories">
                <AccessoryCategoriesPage />
              </Route>
              <Route path="/admin/lenses">
                <LensesPage />
              </Route>
              <Route path="/admin/customers">
                <CustomersPage />
              </Route>
              <Route path="/admin/colors">
                <ColorsPage />
              </Route>
              <Route path="/admin/installment">
                <InstallmentPage />
              </Route>
              <Route path="/admin/forms">
                <FormPage />
              </Route>
              <Route path="/admin/page-builder">
                <PageBuilderPage />
              </Route>
              <Route path="/admin/redirect">
                <RedirectPage />
              </Route>
              <Route path="/admin/coupon">
                <CouponPage />
              </Route>
              <Route path="/admin/color-categories">
                <ColorCategoriesPage />
              </Route>
              <Route path="/admin/special-features">
                <SpecialFeaturesPage />
              </Route>
              <Route path="/admin/insurances">
                <InsurancesPage />
              </Route>
              <Route path="/admin/blogs">
                <BlogsPage />
              </Route>
              <Route path="/admin/shipping-methods">
                <ShippingMethodsPage />
              </Route>
              <Route path="/admin/faq">
                <FaqPage />
              </Route>
              <Route path="/admin/about-us">
                <AboutUs />
              </Route>
              <Route path="/admin/terms-conditions">
                <TermsConditions />
              </Route>
              <Route path="/admin/settings">
                <SettingsPage />
              </Route>
              <Route path="/admin/ads">
                <AdsPage />
              </Route>
              <Route path="/admin/main-page">
                <MainPagePage />
              </Route>
              <Route path="/admin/specials">
                <SpecialSettingPage />
              </Route>
              <Redirect to="/admin/orders" />
            </Switch>
          </AdminPanel>
        </Route>
      </Switch>
    </Router>
  );
}
